function parseBoolean(value: string | undefined, fallback: boolean): boolean {
  if (!value) return fallback
  const normalized = value.trim().toLowerCase()
  if (['false', '0', 'no', 'off'].includes(normalized)) return false
  if (['true', '1', 'yes', 'on'].includes(normalized)) return true
  return fallback
}

export const appConfig = {
  hideEntryCodeForJudges: parseBoolean(import.meta.env.VITE_HIDE_ENTRY_CODE_FOR_JUDGES, true),
  identifiersUnified: true,
}
